import { toast, Toaster, type ToasterProps } from 'sonner';

export type ToastProviderProps = ToasterProps;

export const ToastProvider = ({ ...props }: ToastProviderProps) => (
  <Toaster
    richColors
    closeButton
    position="top-center"
    toastOptions={{ className: 'text-sm' }}
    {...props}
  />
);

export { toast };
